import React, { useMemo } from 'react';
import Col from "react-bootstrap/Col";
import { Button } from 'react-bootstrap';

const TeamScoringControls = (props) => {

    const {
        fixtureDetails,
        homeTeamPlayers,
        awayTeamPlayers,
        selectedPlayer,
        setSelectedPlayer,
        setSelectedScore,
        isMultipleChoiceForPlayer,
        isMultipleChoiceColor,
        setIsMultipleChoiceColor,
        selectedPlayers,
        setSelectedPlayers,
        onShowWatcherCardsMessageModal,
        selectedPlayersTeam,
        setSelectedPlayersTeam,
        isConfirmStartEnd
    } = props;

    const homeTeamPlayersIsCreated = useMemo(() => fixtureDetails?.homeTeamPlayers.filter(x => !x.isCreated), [fixtureDetails]);
    const awayTeamPlayersIsCreated = useMemo(() => fixtureDetails?.awayTeamPlayers.filter(x => !x.isCreated), [fixtureDetails]);
    const incrementMultiplePlayersInput = (key, teamId) => {
        const selectedCount = selectedPlayersTeam[key] ? selectedPlayersTeam[key] : 0;
        const newMultiplePlayersSelectedList = { ...selectedPlayersTeam, teamId }
        newMultiplePlayersSelectedList[key] = selectedCount + 1;
        setSelectedPlayersTeam(newMultiplePlayersSelectedList);
    }

    let getPlayerButton = (currentPlayer, selectedPlayer, incrementMultiplePlayersInput, isMultipleChoiceForPlayer, setIsMultipleChoiceColor, isMultipleChoiceColor, selectedPlayers, setSelectedPlayers, setSelectedScore, setSelectedPlayer) => {
        const variant = selectedPlayer && selectedPlayer.key === currentPlayer.key ? "primary" : "outline-primary";
        return (
            isConfirmStartEnd ? <></> :
            <div key={currentPlayer?.key} style={{ padding: ".1rem .1rem" }}>
                <Button
                    variant={variant}
                    className="btn-block"
                    size="sm"
                    disabled={(selectedPlayersTeam['teamId'] && selectedPlayersTeam['teamId'] !== currentPlayer.teamId)
                        || (isMultipleChoiceForPlayer && (currentPlayer.isYellowCard || currentPlayer.isRedCard))}
                    style={{
                        padding: ".1rem .1rem",
                        fontSize: "12px",
                        backgroundColor:
                            isMultipleChoiceColor &&
                                selectedPlayers.some(
                                    (e) => e.shirtNumber === currentPlayer.shirtNumber && e.teamId === currentPlayer.teamId
                                )
                                ? "#007BFF"
                                : (currentPlayer.isYellowCard) ? "yellow" : (currentPlayer?.isRedCard) ? "red" : "",
                        color:
                            isMultipleChoiceColor &&
                                selectedPlayers.some(
                                    (e) => e.shirtNumber === currentPlayer.shirtNumber && e.teamId === currentPlayer.teamId
                                ) || currentPlayer?.isRedCard
                                ? "white"
                                : (currentPlayer?.isYellowCard) ? "#007BFF" : "",
                    }}
                    onClick={(e) => {
                        if (isMultipleChoiceForPlayer) {
                            e.preventDefault();
                            incrementMultiplePlayersInput(currentPlayer.shirtNumber, currentPlayer.teamId);
                            setSelectedPlayers([...selectedPlayers, currentPlayer,]);
                            setIsMultipleChoiceColor(true);
                        }
                        else {
                            if (selectedPlayer && currentPlayer.key == selectedPlayer.key) {
                                setSelectedPlayer(null);
                                setSelectedScore(null);
                            } else {
                                if (currentPlayer?.isYellowCard || currentPlayer?.isRedCard) {
                                    onShowWatcherCardsMessageModal();
                                    setSelectedPlayer(currentPlayer);
                                }
                                else {
                                    setSelectedPlayer(currentPlayer);
                                }
                            }
                        }
                    }}
                >
                    {currentPlayer?.key}
                </Button>
            </div>
        );
    }

    let teamOneInputs = [];
    let teamTwoInputs = [];

    if (fixtureDetails) {
        const homeTeamPlayersArray = fixtureDetails.isTrackedByAPI || fixtureDetails.isForTraining ? homeTeamPlayers?.filter(x => !x.isCreated) : homeTeamPlayersIsCreated;
        const awayTeamPlayersArray = fixtureDetails.isTrackedByAPI || fixtureDetails.isForTraining ? awayTeamPlayers?.filter(x => !x.isCreated) : awayTeamPlayersIsCreated;
        if (homeTeamPlayersArray) {
            for (let i = (fixtureDetails.isTrackedByAPI ? 1 : 0); i < homeTeamPlayersArray.length; i++) {
                let currentHomePlayer = homeTeamPlayersArray[i];
                teamOneInputs.push(getPlayerButton(currentHomePlayer, selectedPlayer, incrementMultiplePlayersInput, isMultipleChoiceForPlayer, setIsMultipleChoiceColor, isMultipleChoiceColor, selectedPlayers, setSelectedPlayers, setSelectedScore, setSelectedPlayer));
            }
        }

        if (awayTeamPlayersArray) {
            for (let i = (fixtureDetails.isTrackedByAPI ? 1 : 0); i < awayTeamPlayersArray.length; i++) {
                let currentAwayPlayer = awayTeamPlayersArray[i];
                teamTwoInputs.push(getPlayerButton(currentAwayPlayer, selectedPlayer, incrementMultiplePlayersInput, isMultipleChoiceForPlayer, setIsMultipleChoiceColor, isMultipleChoiceColor, selectedPlayers, setSelectedPlayers, setSelectedScore, setSelectedPlayer));
            }
        }
    }


    let getTeamButton = (team) => {
        const variant = selectedPlayer && selectedPlayer.key == team.abbreviation ? "primary" : "outline-primary";
        return (
            isConfirmStartEnd ? <></> :
            <div style={{ padding: ".1rem .1rem" }}>
                <Button
                    variant={variant}
                    className="btn-block"
                    size="sm"
                    disabled={isMultipleChoiceForPlayer}
                    style={{ padding: ".1rem .1rem", fontSize: "12px" }}
                    onClick={(e) => {
                        if (!isMultipleChoiceForPlayer) {
                            if (selectedPlayer && team.abbreviation == selectedPlayer.key) {
                                setSelectedPlayer(null);
                                setSelectedScore(null);
                            } else {
                                setSelectedPlayer({
                                    key: team.abbreviation,
                                    teamId: team.id,
                                    position: -1,
                                });
                            }
                        }
                    }}

                >{team.abbreviation} Team</Button>
            </div>
        );
    }

    return (
        <>
            {fixtureDetails && homeTeamPlayers && awayTeamPlayers &&
                <>
                    <Col style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        {getTeamButton(fixtureDetails.homeTeam)}
                        <div style={{ height: "calc(100vh - 400px)", overflowY: isConfirmStartEnd ? "" : "scroll" }}>
                            {teamOneInputs}
                        </div>
                    </Col>
                    <Col style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        {getTeamButton(fixtureDetails.awayTeam)}
                        <div style={{ height: "calc(100vh - 400px)", overflowY: isConfirmStartEnd ? "" : "scroll" }}>
                            {teamTwoInputs}
                        </div>
                    </Col>
                </>
            }
        </>
    );

}

export default TeamScoringControls;
